import { render } from "./ProgressivePotsTable.vue?vue&type=template&id=a3520f54&scoped=true"
import script from "./ProgressivePotsTable.vue?vue&type=script&lang=js"
export * from "./ProgressivePotsTable.vue?vue&type=script&lang=js"

import "./ProgressivePotsTable.vue?vue&type=style&index=0&id=a3520f54&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\reportpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3520f54"]])

export default __exports__